import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/543516347235?text=Hola!!%20Quiero%20consultar%20sobre%20el%20Mega%20Pack%20Velas%20Comestibles%20Gourmet..%20Gracias!!" target="_blank" rel="noopener noreferrer" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1.5,
    duration: 0.4,
    type: 'spring',
    stiffness: 200
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg shadow-green-500/30 transition-colors" aria-label="Contactar por WhatsApp" data-id="element-239">
      <MessageCircleIcon className="w-7 h-7" data-id="element-240" />
    </motion.a>;
}